/**
 * This is a static holder for the modals so they can be reference w/o loading the root MITS object
 */
'use strict';

var ModalManager = {};

ModalManager.getCurrentModal = function() {
    if (!ModalManager._currentModal) {
        //This is to deal w/ a circular dependency involving ModalManager and Base
        var FadeOutModal = require('./FadeOutModal');
        ModalManager._currentModal = new FadeOutModal();
    }
    return ModalManager._currentModal;
};
ModalManager.getCurrentMessageModal = function() {
    if (typeof ModalManager._currentMessageModal == 'undefined') {
        ModalManager._currentMessageModal = null;
    }
    return ModalManager._currentMessageModal;
};

ModalManager.getCurrentModalWizard = function(){
    if(ModalManager._currentModalWizard == null) {
        //This is to deal w/ a circular dependency involving ModalManager and Base
        var ModalWizard = require('./Modal/ModalWizard');
        //ModalWizard.initialize() assigns itself to _currentModalWizard
        new ModalWizard();
    }
    return ModalManager._currentModalWizard;
};

module.exports = ModalManager;


//////////////////
// WEBPACK FOOTER
// ./mits/Widgets/ModalManager.js
// module id = 2
// module chunks = 0